import React, { Fragment, useContext, useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import DateView from "../Record/DateView";
import { useNavigate } from "react-router-dom";
import { API_RESP_STATUS } from "../../Constant/constant";
import { getBudgetAnalysis } from "../Apis/apis";
import ProgressBar from "@ramonak/react-progress-bar";
import AddDailog from "../Record/AddDailog";
import AllStateContext from "../../context/allstateContext";
import AccountDialog from "../Record/AccountDialog";
import DateDialog from "../../Common/DateDialog";
import TimeDialog from "../../Common/TimeDialog";
import { useQuery } from "react-query";
import { formatDate } from "../../Common/Common";
import CategoryTransactionsDialog from "../../Common/CategoryTransactionsDialog";

const Analisys = () => {
  const history = useNavigate();
  const [series, setSeries] = useState([]);
  const [labels, setLabels] = useState([]);
  const [options, setOptions] = useState({});
  const { openAccount, openDateDialog, openTimeDialog, startEndDate, setSearchDetail } =
    useContext(AllStateContext);
  const [selectedOption, setSelectedOption] = useState("expense");
  const [showCategoryTx, setShowCategoryTx] = useState(false);
  const [selectedCategoryName, setSelectedCategoryName] = useState("");

  const handleSelectionChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const { data, error, isLoading, refetch } = useQuery(
    ["recordListApiCall", startEndDate, selectedOption],
    async () => {
      const showAll = true;
      const response = await getBudgetAnalysis(
        { type: selectedOption === "expense" ? 1 : 2 },
        formatDate(startEndDate.startDate),
        "",
        showAll
      );
      if (response.data.status == API_RESP_STATUS.success) {
        let dataArray = [];
        let nameArray = [];
        await response.data.payload.data.map((item) => {
          if (item?.spent) {
            dataArray.push(item.spent);
            nameArray.push(item.name);
          }
        });
        setSeries(dataArray);
        setLabels(nameArray);

        await setOptions({
          chart: {
            width: 380,
            type: "donut",
            background: "transparent",
            dropShadow: {
              enabled: true,
              color: 'var(--primary)',
              top: 0,
              left: 0,
              blur: 8,
              opacity: 0.1
            }
          },
          theme: {
            mode: document.documentElement.getAttribute("data-theme") === "light" ? "light" : "dark"
          },
          stroke: {
            show: true,
            colors: ["var(--bg-secondary)"],
            width: 4
          },
          colors: ['#d9f99d', '#bef264', '#c4b5fd', '#a78bfa', '#fb7185', '#60a5fa', '#818cf8', '#2dd4bf'],
          plotOptions: {
            pie: {
              donut: {
                size: '78%',
                labels: {
                  show: true,
                  name: {
                    show: true,
                    fontSize: '14px',
                    fontFamily: 'Outfit, sans-serif',
                    color: 'var(--text-secondary)',
                    offsetY: -10
                  },
                  value: {
                    show: true,
                    fontSize: '28px',
                    fontFamily: 'Outfit, sans-serif',
                    fontWeight: 800,
                    color: 'var(--text-primary)',
                    formatter: function (val) {
                      return "₹" + parseInt(val).toLocaleString("en-IN")
                    }
                  }
                }
              }
            }
          },
          dataLabels: {
            enabled: false
          },
          labels: nameArray,
          legend: {
            show: false
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 280,
                }
              },
            },
          ],
        });
      }
      return response.data;
    }
  );
  if (error) {
    if (error.response.status == API_RESP_STATUS.unauthorized) {
      localStorage.removeItem("token");
      history("/login");
    }
  }

  return (
    <div className="container" style={{ paddingBottom: "40px" }}>
      <div>
        {isLoading ? (
          <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            <DateView
              totalExpense={data?.payload?.totalInEx?.totalExpense}
              totalIncome={data?.payload?.totalInEx?.totalIncome}
              dateUpdate={"handleStartEndDate" && ""}
            />
            <AddDailog fetchData={refetch} />
            {openAccount && <AccountDialog />}
            {openDateDialog && <DateDialog />}
            {openTimeDialog && <TimeDialog />}
            <CategoryTransactionsDialog
               open={showCategoryTx}
               onClose={() => {
                 setShowCategoryTx(false);
                 setSelectedCategoryName("");
               }}
               categoryName={selectedCategoryName}
               startDate={formatDate(startEndDate.startDate)}
             />

            <div className="glass-card mb-4" style={{ padding: "24px" }}>
              <div className="d-flex align-items-center justify-content-between mb-4">
                <h5 style={{ fontWeight: "700", margin: "0", letterSpacing: "0.02em" }}>
                  Category Breakdown
                </h5>
                <select
                  value={selectedOption}
                  onChange={handleSelectionChange}
                  className="form-select"
                  style={{
                    width: "150px",
                    fontSize: "0.9rem",
                    padding: "6px 36px 6px 12px",
                    backgroundPosition: "right 12px center"
                  }}
                >
                  <option value="expense">Expense</option>
                  <option value="income">Income</option>
                </select>
              </div>

              <div
                id="chart"
                className="d-flex justify-content-center py-4 mb-4"
                style={{
                  background: "var(--bg-surface)",
                  borderRadius: "16px",
                  border: "1px solid var(--border-color)"
                }}
              >
                <ReactApexChart
                  options={options}
                  series={series}
                  type="donut"
                  width={420}
                />
              </div>

              <div className="list-group" style={{ margin: "0", border: "1px solid var(--border-color)" }}>
                {data && data?.payload?.data?.map((item) => 
                  item.spent && (
                    <div
                      className="list-group-item d-flex align-items-center justify-content-between"
                      key={item?.categoryId}
                      onClick={() => {
                        setSelectedCategoryName(item.name);
                        setShowCategoryTx(true);
                      }}
                      style={{
                        padding: "16px 20px !important",
                        borderBottom: "1px solid var(--border-color)",
                        cursor: "pointer"
                      }}
                    >
                      <div className="d-flex align-items-center gap-3 w-70" style={{ flex: "1" }}>
                        <div 
                          style={{
                            width: "44px",
                            height: "44px",
                            borderRadius: "10px",
                            background: "var(--bg-surface-hover)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid var(--border-color)"
                          }}
                        >
                          <img
                            style={{ height: "28px", width: "28px" }}
                            src={item?.iconDetail?.icon}
                            alt={item?.name}
                          />
                        </div>
                        <div style={{ flex: "1" }}>
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <span style={{ fontWeight: "700", fontSize: "1rem", letterSpacing: "0.02em" }}>{item.name}</span>
                            <span style={{ fontSize: "0.85rem", fontWeight: "700", color: "var(--text-secondary)", letterSpacing: "0.05em" }}>
                              {((item.spent / data?.payload?.totalInEx?.totalSpent) * 100).toFixed(2) + "%"}
                            </span>
                          </div>
                          <div style={{ width: "100%", marginTop: "8px", filter: `drop-shadow(0 0 6px ${item.type === 1 ? "var(--danger-glow)" : "var(--success-glow)"})` }}>
                            <ProgressBar
                              completed={parseFloat(((item.spent / data?.payload?.totalInEx?.totalSpent) * 100).toFixed(1))}
                              maxCompleted={100}
                              width="100%"
                              bgColor={item.type === 1 ? "var(--danger)" : "var(--success)"}
                              baseBgColor="rgba(255,255,255,0.03)"
                              height="4px"
                              customLabel={" "}
                            />
                          </div>
                        </div>
                      </div>
                      <div 
                        style={{
                          fontSize: "1rem",
                          fontWeight: "700",
                          color: item?.type === 1 ? "var(--danger)" : "var(--success)",
                          marginLeft: "24px"
                        }}
                      >
                        {item?.type === 1 ? `-₹${item.spent.toLocaleString("en-IN")}` : `+₹${item.spent.toLocaleString("en-IN")}`}
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Analisys;
